// The accepted_no_email tab hangs a "Classify:" strip under every candidate row,
// which doubles the height of the table. Two levels of folding, both delegated
// from the document:
//
//   * a caret in the candidate row hides that candidate's whole classification row
//   * a caret inside the strip folds just the status chips, keeping the label and
//     the current status on screen
//
// A collapsed strip still shows the current status, because those chips are the
// only place it is rendered — the row itself only carries it as data-status.
const GROUP = "[data-classify]";

let bound = false;

function describe(btn: HTMLElement, off: boolean, verb: string): void {
  const label = `${off ? "Show" : "Hide"} ${verb}`;
  btn.setAttribute("aria-expanded", off ? "false" : "true");
  btn.setAttribute("aria-label", label);
  btn.setAttribute("title", label);
}

// Row-level: the caret sits in the candidate row, the target is the sibling
// <tr class="classify-row"> tied to it by data-parent.
function toggleRow(btn: HTMLElement): void {
  const parentId = btn.dataset.classifyRowToggle;
  if (!parentId) return;

  const row = document.querySelector<HTMLElement>(`tr.classify-row[data-parent="${parentId}"]`);
  if (!row) return;

  const off = !row.hidden;
  row.hidden = off;
  // The caret's own rotation hangs off the candidate row, which is also what a
  // Turbo restore re-renders, so the two never disagree.
  document.getElementById(parentId)?.classList.toggle("classify-hidden", off);
  describe(btn, off, "classification row");
}

// Group-level: fold the chips inside one strip.
function toggleGroup(btn: HTMLElement): void {
  const group = btn.closest<HTMLElement>(GROUP);
  if (!group) return;

  describe(btn, group.classList.toggle("collapsed"), "classification");
}

export function initCandidateClassify(): void {
  // Delegated and guarded by a module flag rather than a data-attribute: the rows
  // are re-rendered on every filter submit, and an attribute guard would not
  // survive a Turbo restore.
  if (bound) return;
  bound = true;

  document.addEventListener("click", (e) => {
    const target = e.target as HTMLElement;

    const rowBtn = target.closest<HTMLElement>("[data-classify-row-toggle]");
    if (rowBtn) {
      e.preventDefault();
      toggleRow(rowBtn);
      return;
    }

    const groupBtn = target.closest<HTMLElement>("[data-classify-toggle]");
    if (groupBtn) {
      e.preventDefault();
      toggleGroup(groupBtn);
    }
  });
}
